import i18n from 'helpers/i18n';
import messages from './messages';
import Title from 'design-system/Title';
import useDocumentTitle from 'hooks/useDocumentTitle';
import { TrainingList } from 'components/TrainingHistory/TrainingList';
import { TrainingSummary } from 'components/TrainingHistory/TrainingSummary';
import { LearningResources } from 'components/TrainingHistory/LearningResources';

function TrainingHistoryPage() {
  useDocumentTitle(i18n.ft(messages.title));

  return (
    <>
      <main className="max-w-7xl mx-auto font-sans text-black">
        <Title>{i18n.ft(messages.title)}</Title>
        <div className="flex flex-col gap-16">
          <TrainingList />
          <TrainingSummary />
          <LearningResources />
        </div>
      </main>
    </>
  );
}

export default TrainingHistoryPage;
